import { ChevronLeft, ChevronRight } from "lucide-react";

function slugify(value) {
  return String(value || "list")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function PaginationFooter({
  pageCount,
  rangeStart,
  rangeEnd,
  total,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  label,
}) {
  if (!pageCount || pageCount <= 1) return null;

  const slug = slugify(label);
  // Keep BOTH controls in the tab order at a page boundary. If a focused button
  // flipped to the native `disabled` state, focus would drop to <body> and the
  // keyboard/screen-reader user would lose their place. Instead we mark the
  // boundary with aria-disabled + a guarded no-op onClick, so focus is retained
  // and assistive tech still announces the dimmed control.
  const buttonClass =
    "inline-flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 text-slate-600 transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:hover:bg-transparent dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700 dark:aria-disabled:hover:bg-transparent";

  return (
    <nav
      className="mt-3 flex items-center justify-center gap-2"
      aria-label={`${label} pagination`}
    >
      <button
        type="button"
        aria-label={`Previous page, ${label}`}
        aria-disabled={!hasPrev}
        onClick={hasPrev ? onPrev : undefined}
        className={buttonClass}
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      <span
        aria-live="polite"
        className="text-xs text-slate-500 dark:text-slate-400"
        data-testid={`pagination-range-${slug}`}
      >
        {rangeStart}–{rangeEnd} of {total}
      </span>
      <button
        type="button"
        aria-label={`Next page, ${label}`}
        aria-disabled={!hasNext}
        onClick={hasNext ? onNext : undefined}
        className={buttonClass}
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </nav>
  );
}
